/** Primary action buttons shown on each seller dashboard module tab. */
export const SELLER_DASHBOARD_MODULE_ACTIONS = {
  overview: [
    { label: "View RFQs", to: "/seller-rfq-list", primary: true },
    { label: "Purchase orders", to: "/seller-purchase-order-list", primary: false },
  ],
  rfq: [
    { label: "Buyer RFQ list", to: "/seller-rfq-list", primary: true },
    { label: "Clarifications", to: "/clarification-list", primary: false },
  ],
  cm: [
    { label: "CM RFQs", to: "/seller/cm-rfqs", primary: true },
    { label: "Generate invoice", to: "/generate-invoice", primary: false },
  ],
  p2p: [
    { label: "Command centre", to: "/dashboard/p2p/command-centre", primary: true },
    { label: "My approvals", to: "/dashboard/p2p/my-approvals", primary: false },
  ],
  infra: [
    { label: "My properties", to: "/infrastructure-leasing/my-properties-assets", primary: true },
    { label: "Create listing", to: "/infrastructure-leasing/create-listing", primary: false },
  ],
  logistics: [
    { label: "Logistics RFQs", to: "/logistics-rfqs-sent", primary: true },
    { label: "Shipping manifests", to: "/shipping-manifest-generation-list", primary: false },
  ],
  auctions: [
    { label: "My listings", to: "/auction/my/listings", primary: true },
    { label: "Create auction", to: "/auction/create", primary: false },
  ],
  fulfilment: [
    { label: "Purchase orders", to: "/seller-purchase-order-list", primary: true },
    { label: "Invoice list", to: "/invoice-list", primary: false },
  ],
};

export function getSellerDashboardModuleActions(moduleKey) {
  return SELLER_DASHBOARD_MODULE_ACTIONS[moduleKey] || SELLER_DASHBOARD_MODULE_ACTIONS.overview;
}

/** Dashboard routes — tab click stays on seller dashboard with module-specific data. */
export const SELLER_DASHBOARD_MODULE_ROUTES = {
  overview: "/dashboard/seller",
  rfq: "/dashboard/seller/rfq",
  cm: "/dashboard/seller/cm",
  p2p: "/dashboard/seller/p2p",
  infra: "/dashboard/seller/infra",
  logistics: "/dashboard/seller/logistics",
  auctions: "/dashboard/seller/auctions",
  fulfilment: "/dashboard/seller/fulfilment",
};
